// event values should always be snake_case
// all custom properties within additionalParameters should be camelCased
export interface DatalayerItem {
  event: string;
  value?: string | number;
}

export enum CarouselSlideEventType {
  SLIDE_NEXT = 'slide_next',
  SLIDE_PREVIOUS = 'slide_previous',
}

export enum CarouselPlayEventType {
  PLAY = 'play',
  PAUSE = 'pause',
}

declare global {
  interface Window {
    dataLayer?: DatalayerItem[];
  }
}

const defaultItem: DatalayerItem = {
  event: undefined,
  value: undefined,
};

export const TrackingService = {
  push(item: any = defaultItem): void {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(item);
  },
};
